var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.46,
    height: 24.325,
    viewBox: "0 0 19.46 24.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16755",
    "data-name": "Path 16755",
    d: "M8.865,19.028H18.6V21.46H8.865Zm0-4.865H18.6V16.6H8.865ZM16.163,2H6.433A2.44,2.44,0,0,0,4,4.433v19.46a2.429,2.429,0,0,0,2.42,2.433H21.028a2.44,2.44,0,0,0,2.433-2.433V9.3Zm4.865,21.893H6.433V4.433h8.514v6.081h6.081Z",
    transform: "translate(-4 -2)",
    fill: "#0074b0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIconBlue);
export default __webpack_public_path__ + "static/media/printIcon-blue.edadb4232962da840156fc2d9e7a7ba9.svg";
export { ForwardRef as ReactComponent };